import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useSalaryPeriodSchema = () => {
    const { t } = useTranslation();
    const requiredMessage = t('yup.validators.required');

    return Yup.object().shape({
        dateIndemnisationCcn: Yup.date().nullable(),
        salaryReferences: Yup.object()
            .shape({
                salaries: Yup.array()
                    .of(
                        Yup.object().shape({
                            id: Yup.string().required(),
                            startDate: Yup.string().optional(),
                            endDate: Yup.string().optional(),
                            salaryBrut: Yup.string().optional(),
                            primesBrut: Yup.string().optional(),
                            salaryNet: Yup.string().optional(),
                            primesNet: Yup.string().optional(),
                        }),
                    )
                    .required(requiredMessage), // Required message for the array itself
            })
            .required(requiredMessage), // Ensuring salaryReferences itself is required
        suspensions: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.string().required(),
                    startDate: Yup.date()
                        .nullable()
                        .test('custom-validation-startDate', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { endDate } = parent;
                            const hasValue = !!endDate;
                            if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                            return true;
                        }),
                    endDate: Yup.date()
                        .nullable()
                        .test('custom-validation-endDate', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { startDate } = parent;
                            const hasValue = !!startDate;
                            if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                            return true;
                        }),
                }),
            )
            .required(requiredMessage), // Required message for suspensions array
    });
};
